import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from 'utils/redux';
import { isIconiqa } from './utils/validators/HelperFunctions';
import './index.scss';

if (isIconiqa()) {
  document.body.setAttribute('data-iconiqa', 'true');

  const applyFonts = () => {
    document.body.style.fontFamily = 'Gotham, sans-serif';

    const cinzelElements = document.querySelectorAll('.font-cinzel');
    cinzelElements.forEach(el => {
      (el as HTMLElement).style.fontFamily = 'Cinzel, serif';
    });
  };

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      applyFonts();
    });
  } else {
    setTimeout(applyFonts, 200);
  }
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StyledEngineProvider injectFirst>
    <CssBaseline />
    <Provider store={store}>
      <Router basename={process.env.PUBLIC_URL || '/'}>
        <App />
      </Router>
    </Provider>
  </StyledEngineProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
